import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenDecodeService {

  constructor() { }

  public GetNamePOS() : any
  {
    let jsontoken = JSON.parse(window.localStorage.getItem('user'));  
    return this.ParseToken(jsontoken.Token.access_token);
  }

  private ParseToken(token : any)
  {
    try {
      // Get Token Header
      const base64HeaderUrl = token.split('.')[0];
      const base64Header = base64HeaderUrl.replace('-', '+').replace('_', '/');
      const headerData = JSON.parse(window.atob(base64Header));
  
      // Get Token payload and date's
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const dataJWT = JSON.parse(window.atob(base64));
      dataJWT.header = headerData;
  
  // TODO: add expiration at check ...
  
  
      return dataJWT;
    } catch (err) {
      return false;
    }
  }
}
